export const reverseGeocode = async (
  lat: number,
  lng: number
): Promise<string> => {
  try {
    const url = `https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=json&location=${lng},${lat}`;

    const response = await fetch(url);
    const data = await response.json();

    return data?.address?.Match_addr || "Unknown Location";
  } catch (error) {
    console.error("Reverse geocode error:", error);
    return "Unable to fetch address";
  }
};
